import React, { useEffect } from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import FormularioNichos from "./components/FormularioNichos";


export default function AnywhereOffice() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <Header />
            <Box sx={{ background: "#fff", marginTop: 2 }}>
                {/* HERO */}
                <Box
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                        py: { xs: 10, md: 18 },
                        background: `
                            radial-gradient(circle at top left, rgba(156,1,185,0.12), transparent 40%),
                            radial-gradient(circle at bottom right, rgba(30,255,134,0.10), transparent 40%),
                            #FFFFFF
                        `,
                    }}
                >
                    {/* Glow Roxo */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 450,
                            height: 450,
                            background: "#9C01B9",
                            opacity: 0.08,
                            borderRadius: "50%",
                            filter: "blur(120px)",
                            top: -150,
                            left: -150,
                        }}
                    />

                    {/* Glow Verde */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 400,
                            height: 400,
                            background: "#1EFF86",
                            opacity: 0.08,
                            borderRadius: "50%",
                            filter: "blur(120px)",
                            bottom: -150,
                            right: -100,
                        }}
                    />

                    <Container maxWidth="lg">
                        <Stack
                            spacing={4}
                            alignItems="center"
                            textAlign="center"
                            sx={{
                                position: "relative",
                                zIndex: 2,
                            }}
                        >
                            {/* Badge */}
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                    backdropFilter: "blur(10px)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        fontWeight: 700,
                                        color: "#9C01B9",
                                    }}
                                >
                                    ESPECIALISTAS EM ANYWHERE OFFICE
                                </Typography>
                            </Box>

                            {/* Título */}
                            <Typography
                                component="h1"
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1,
                                    letterSpacing: "-0.04em",
                                    maxWidth: 1000,
                                    fontSize: {
                                        xs: "2.8rem",
                                        sm: "4rem",
                                        md: "5.5rem",
                                    },
                                }}
                            >
                                Contabilidade para{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background:
                                            "linear-gradient(90deg,#9C01B9 0%, #1EFF86 100%)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Anywhere Office
                                </Box>
                            </Typography>

                            {/* Subtítulo */}
                            <Typography
                                sx={{
                                    maxWidth: 800,
                                    color: "#5A5A5A",
                                    fontWeight: 400,
                                    lineHeight: 1.7,
                                    fontSize: {
                                        xs: "1.05rem",
                                        md: "1.35rem",
                                    },
                                }}
                            >
                                Receber em dólar sem estrutura PJ pode custar até 27,5% de imposto sobre cada transferência. Com CNPJ e isenção de exportação configurada, você pode reduzir isso a quase zero em impostos sobre serviços.
                            </Typography>

                            {/* CTA */}
                            <Button
                                size="large"
                                sx={{
                                    px: 5,
                                    py: 2,
                                    borderRadius: "16px",
                                    fontWeight: 800,
                                    fontSize: "1rem",
                                    textTransform: "none",
                                    background:
                                        "linear-gradient(135deg,#9C01B9 0%, #B800D8 100%)",
                                    color: "#FFF",
                                    boxShadow:
                                        "0 20px 40px rgba(156,1,185,0.30)",
                                    transition: ".3s",
                                    "&:hover": {
                                        transform: "translateY(-3px)",
                                        boxShadow:
                                            "0 30px 60px rgba(156,1,185,0.45)",
                                    },
                                }}
                            >
                                Falar com Especialista
                            </Button>

                            {/* Trust Indicators */}
                            <Stack
                                direction={{ xs: "column", sm: "row" }}
                                spacing={3}
                                sx={{
                                    mt: 2,
                                }}
                            >
                                {[
                                    "Atendimento em todo Brasil",
                                    "100% Digital",
                                    "Especialistas no Nicho",
                                ].map((item) => (
                                    <Stack
                                        key={item}
                                        direction="row"
                                        spacing={1}
                                        alignItems="center"
                                    >
                                        <Box
                                            sx={{
                                                width: 10,
                                                height: 10,
                                                borderRadius: "50%",
                                                background: "#1EFF86",
                                                boxShadow:
                                                    "0 0 12px #1EFF86",
                                            }}
                                        />

                                        <Typography
                                            sx={{
                                                color: "#444",
                                                fontWeight: 600,
                                            }}
                                        >
                                            {item}
                                        </Typography>
                                    </Stack>
                                ))}
                            </Stack>
                        </Stack>
                    </Container>
                </Box>

                {/* DORES */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        position: "relative",
                        overflow: "hidden",
                        background: "#FAFAFA",
                    }}
                >
                    {/* Glow */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 500,
                            height: 500,
                            background: "#9C01B9",
                            opacity: 0.05,
                            borderRadius: "50%",
                            filter: "blur(140px)",
                            top: -200,
                            right: -150,
                        }}
                    />

                    <Container maxWidth="lg">
                        {/* Cabeçalho */}
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 8 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 13,
                                        fontWeight: 700,
                                        color: "#9C01B9",
                                        letterSpacing: 1,
                                    }}
                                >
                                    PRINCIPAIS DESAFIOS
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    maxWidth: 900,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Os problemas que mais afetam{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background:
                                            "linear-gradient(90deg,#9C01B9,#C300E5)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Anywhere Office
                                </Box>
                            </Typography>

                            <Typography
                                sx={{
                                    maxWidth: 750,
                                    color: "#666",
                                    fontSize: {
                                        xs: "1rem",
                                        md: "1.15rem",
                                    },
                                    lineHeight: 1.8,
                                }}
                            >
                                Um profissional remoto que fatura R$15.000/mês em dólar sem estrutura PJ pode estar pagando mais de R$4.125 em imposto. Com CNPJ estruturado para exportação de serviços, é possível reduzir o ISS, PIS e COFINS a zero, e ainda pagar apenas a partir de 6% de DAS sobre o faturamento.
                            </Typography>
                        </Stack>

                        {/* Cards */}
                        <Grid container spacing={3} sx={{ justifyContent: "center" }}>
                            {[
                                {
                                    title: "Imposto alto sem estrutura PJ",
                                    description: "Você recebe via Wise, Payoneer ou conta no exterior e não sabe exatamente o que declarar.",
                                },
                                {
                                    title: "Risco de notificações da Receita",
                                    description: "Tem medo que as transferências internacionais apareçam na Receita sem que você tenha declarado.",
                                },
                                {
                                    title: "Dificuldade para abrir CNPJ",
                                    description: "Não tem endereço fixo no Brasil, o que complica ter um CNPJ estável.",
                                },
                                {
                                    title: "Perda de contratos por falta de nota fiscal",
                                    description: "Clientes estrangeiros pedem invoice e você não sabe como emitir corretamente.",
                                },
                                {
                                    title: "Dificuldade para comprovar renda",
                                    description: "Não tem comprovação de renda formal para financiar um imóvel ou veículo no Brasil.",
                                },
                            ].map((item, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <Card
                                        sx={{
                                            height: "100%",
                                            width: window.innerWidth < 600 ? "100%" : "300px",
                                            borderRadius: "28px",
                                            background:
                                                "rgba(255,255,255,0.8)",
                                            backdropFilter: "blur(20px)",
                                            border:
                                                "1px solid rgba(0,0,0,0.05)",
                                            boxShadow:
                                                "0 20px 60px rgba(0,0,0,0.06)",
                                            transition: ".35s",
                                            position: "relative",
                                            overflow: "hidden",

                                            "&:hover": {
                                                transform:
                                                    "translateY(-8px)",
                                                boxShadow:
                                                    "0 30px 80px rgba(156,1,185,0.12)",
                                            },

                                            "&:before": {
                                                content: '""',
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: 4,
                                                background:
                                                    "linear-gradient(90deg,#9C01B9,#1EFF86)",
                                            },
                                        }}
                                    >
                                        <CardContent
                                            sx={{
                                                p: 4,
                                            }}
                                        >
                                            {/* Número */}
                                            <Typography
                                                sx={{
                                                    fontSize: "4rem",
                                                    fontWeight: 900,
                                                    color:
                                                        "rgba(156,1,185,0.08)",
                                                    lineHeight: 1,
                                                    mb: 2,
                                                }}
                                            >
                                                0{index + 1}
                                            </Typography>

                                            {/* Ícone */}
                                            <Box
                                                sx={{
                                                    width: 64,
                                                    height: 64,
                                                    borderRadius: "18px",
                                                    background:
                                                        "rgba(156,1,185,0.08)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mb: 3,
                                                }}
                                            >
                                                <WarningAmberIcon
                                                    sx={{
                                                        color: "#9C01B9",
                                                        fontSize: 32,
                                                    }}
                                                />
                                            </Box>

                                            <Typography
                                                sx={{
                                                    fontWeight: 800,
                                                    fontSize: "1.3rem",
                                                    mb: 2,
                                                }}
                                            >
                                                {item.title}
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#666",
                                                    lineHeight: 1.8,
                                                }}
                                            >
                                                {item.description}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </Box>

                {/* BENEFÍCIOS */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        background: "#050505",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    {/* Glow Roxo */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 500,
                            height: 500,
                            borderRadius: "50%",
                            background: "#9C01B9",
                            opacity: 0.15,
                            filter: "blur(180px)",
                            top: -250,
                            left: -250,
                        }}
                    />

                    {/* Glow Verde */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 450,
                            height: 450,
                            borderRadius: "50%",
                            background: "#1EFF86",
                            opacity: 0.08,
                            filter: "blur(180px)",
                            bottom: -250,
                            right: -250,
                        }}
                    />

                    <Container maxWidth="lg">
                        {/* Cabeçalho */}
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 8 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(255,255,255,0.05)",
                                    border: "1px solid rgba(255,255,255,0.08)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#1EFF86",
                                        fontSize: 13,
                                        fontWeight: 700,
                                        letterSpacing: 1,
                                    }}
                                >
                                    A SOLUÇÃO
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    color: "#FFF",
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    maxWidth: 900,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Como a{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background: "#1EFF86",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Contblack
                                </Box>{" "}
                                ajuda você a crescer com segurança
                            </Typography>

                            <Typography
                                sx={{
                                    color: "rgba(255,255,255,0.7)",
                                    maxWidth: 750,
                                    lineHeight: 1.8,
                                    fontSize: {
                                        xs: "1rem",
                                        md: "1.15rem",
                                    },
                                }}
                            >
                                A ContBlack é especialista em estrutura fiscal para quem vive e trabalha de forma remota e internacional. Abrimos seu CNPJ com endereço fiscal virtual (para quem não tem endereço fixo), configuramos a isenção de exportação de serviços, orientamos sobre câmbio e garantimos que cada transferência seja declarada da forma mais vantajosa possível.
                            </Typography>
                        </Stack>

                        {/* Benefícios */}
                        <Grid container spacing={4} sx={{ justifyContent: "center" }}>
                            {[
                                {
                                    title: "Menos Impostos em Receitas Internacionais",
                                    description: "Isenção de ISS, PIS e COFINS na exportação de serviços para clientes estrangeiros.",
                                    result: "Redução da carga tributária e aumento da lucratividade sobre pagamentos recebidos do exterior.",
                                },
                                {
                                    title: "Endereço Fiscal para Nômades Digitais",
                                    description: "Endereço fiscal virtual em Curitiba-PR, aceito pela Receita Federal, ideal para nômades.",
                                    result: "Regularização da empresa com um endereço válido, sem necessidade de manter escritório físico.",
                                },
                                {
                                    title: "Suporte para Recebimentos Internacionais",
                                    description: "Orientação sobre câmbio, Wise, Payoneer e contas em bancos estrangeiros.",
                                    result: "Recebimentos mais seguros, organizados e com menor perda financeira em taxas e conversões.",
                                },
                                {
                                    title: "Invoices Sem Erros Fiscais",
                                    description: "Emissão de invoice correta para clientes no exterior com documentação fiscal adequada.",
                                    result: "Mais profissionalismo nas cobranças internacionais e redução de riscos fiscais.",
                                },
                                {
                                    title: "Imposto de Renda para Rendimentos do Exterior",
                                    description: "Declaração de IRPF com rendimentos do exterior de forma segura e vantajosa.",
                                    result: "Conformidade com a Receita Federal e aproveitamento correto das regras tributárias.",
                                },
                                {
                                    title: "Comprovação de Renda Simplificada",
                                    description: "Relatórios financeiros em português para comprovação de renda em bancos brasileiros.",
                                    result: "Maior facilidade para financiamentos, cartões de crédito e abertura de contas no Brasil.",
                                },
                            ].map((item, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <Card
                                        sx={{
                                            height: "100%",
                                            width: window.innerWidth < 600 ? "100%" : "300px",
                                            background:
                                                "rgba(255,255,255,0.04)",
                                            backdropFilter: "blur(20px)",
                                            border:
                                                "1px solid rgba(255,255,255,0.08)",
                                            borderRadius: "28px",
                                            position: "relative",
                                            overflow: "hidden",
                                            transition: ".35s",

                                            "&:hover": {
                                                transform:
                                                    "translateY(-8px)",
                                                border:
                                                    "1px solid rgba(30,255,134,0.25)",
                                                boxShadow:
                                                    "0 30px 80px rgba(30,255,134,0.08)",
                                            },

                                            "&::before": {
                                                content: '""',
                                                position: "absolute",
                                                left: 0,
                                                top: 0,
                                                width: 4,
                                                height: "100%",
                                                background:
                                                    "linear-gradient(180deg,#9C01B9,#1EFF86)",
                                            },
                                        }}
                                    >
                                        <CardContent sx={{ p: 4 }}>
                                            <Box
                                                sx={{
                                                    width: 70,
                                                    height: 70,
                                                    borderRadius: "20px",
                                                    background:
                                                        "rgba(30,255,134,0.08)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mb: 3,
                                                }}
                                            >
                                                <CheckCircleIcon
                                                    sx={{
                                                        fontSize: 38,
                                                        color: "#1EFF86",
                                                    }}
                                                />
                                            </Box>

                                            <Typography
                                                sx={{
                                                    color: "#FFF",
                                                    fontWeight: 800,
                                                    fontSize: "1.35rem",
                                                    mb: 2,
                                                }}
                                            >
                                                {item.title}
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color:
                                                        "rgba(255,255,255,0.7)",
                                                    lineHeight: 1.8,
                                                    mb: 3,
                                                }}
                                            >
                                                {item.description}
                                            </Typography>

                                            <Box
                                                sx={{
                                                    borderTop:
                                                        "1px solid rgba(255,255,255,0.08)",
                                                    pt: 2,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: "#1EFF86",
                                                        fontWeight: 700,
                                                        fontSize: ".95rem",
                                                    }}
                                                >
                                                    ✓ {item.result}
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </Box>

                {/* FAQ */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        background: "#FFFFFF",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <Container maxWidth="md">
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 7 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#9C01B9",
                                        fontSize: 13,
                                        fontWeight: 700,
                                        letterSpacing: 1,
                                    }}
                                >
                                    DÚVIDAS FREQUENTES
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Perguntas que recebemos com frequência
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#666",
                                    maxWidth: 700,
                                    lineHeight: 1.8,
                                }}
                            >
                                Separamos as principais dúvidas sobre contabilidade,
                                tributação e regularização para Anywhere Office.
                            </Typography>
                        </Stack>

                        {[
                            {
                                question: "Posso ter CNPJ sem endereço fixo no Brasil?",
                                answer: "Sim. O endereço fiscal virtual da ContBlack em Curitiba-PR é aceito pela Receita Federal para registro de CNPJ.",
                            },
                            {
                                question: "O que é isenção de exportação de serviços?",
                                answer: "Serviços prestados para clientes no exterior são isentos de ISS, PIS e COFINS. Isso pode reduzir significativamente a carga tributária sobre receitas internacionais.",
                            },
                            {
                                question: "Preciso declarar o que recebo via Wise?",
                                answer: "Sim. A ContBlack orienta sobre o tratamento correto de cada tipo de recebimento para evitar problemas com a Receita Federal.",
                            }
                        ].map((item, index) => (
                            <Accordion
                                key={index}
                                disableGutters
                                elevation={0}
                                sx={{
                                    mb: 2,
                                    borderRadius: "20px !important",
                                    overflow: "hidden",
                                    border: "1px solid rgba(0,0,0,0.08)",
                                    boxShadow:
                                        "0 10px 30px rgba(0,0,0,0.04)",

                                    "&:before": {
                                        display: "none",
                                    },
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            sx={{
                                                color: "#9C01B9",
                                            }}
                                        />
                                    }
                                    sx={{
                                        minHeight: 80,
                                        px: 3,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            fontSize: {
                                                xs: "1rem",
                                                md: "1.1rem",
                                            },
                                        }}
                                    >
                                        {item.question}
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails
                                    sx={{
                                        px: 3,
                                        pb: 3,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#666",
                                            lineHeight: 1.8,
                                        }}
                                    >
                                        {item.answer}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}

                        {/* CTA Final */}
                        <Box
                            sx={{
                                mt: 6,
                                p: 4,
                                borderRadius: "24px",
                                background:
                                    "linear-gradient(135deg, rgba(156,1,185,0.05), rgba(30,255,134,0.05))",
                                border: "1px solid rgba(156,1,185,0.08)",
                                textAlign: "center",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 800,
                                    fontSize: {
                                        xs: "1.2rem",
                                        md: "1.5rem",
                                    },
                                    mb: 1,
                                }}
                            >
                                Ainda ficou com alguma dúvida?
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#666",
                                    mb: 3,
                                }}
                            >
                                Converse com um especialista e receba uma orientação
                                personalizada para sua situação.
                            </Typography>

                            <Button
                                sx={{
                                    background: "#9C01B9",
                                    color: "#FFF",
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: "14px",
                                    fontWeight: 700,

                                    "&:hover": {
                                        background: "#83009A",
                                    },
                                }}
                            >
                                Falar com Especialista
                            </Button>
                        </Box>
                    </Container>
                </Box>

                <FormularioNichos nicho="Anywhere Office" />

                {/* FOOTER */}
                <Footer />
            </Box>
        </>
    );
}